module.exports = __webpack_public_path__ + "static/media/isotop_6.bf5c778d.jpeg";